import {useMutation} from '@tanstack/react-query';
import {sendMessage} from '@/api/help/chatbot';
import {formatCurrentTime} from '@/utils/help/chatbot';
import {BotMessageType} from '@/components/help/common/Chatbot/type';
import {SOOP} from '@/constants/help/chatbot';

export const useSendMessage = ({
  onSuccess,
  onError,
}: {
  onSuccess: (message: BotMessageType) => void;
  onError: () => void;
}) => {
  return useMutation({
    mutationFn: sendMessage,
    onSuccess: (data) => {
      if ('status' in data && data.status === 'success') {
        const message: BotMessageType = {
          role: SOOP,
          text: data.full,
          links: data.links,
          keywords: [],
          date: formatCurrentTime(),
        };

        // 고객센터 메시지 추가
        if (data.helpInfo) {
          message.text += `\n\n${data.helpInfo.title}\n${data.helpInfo.description}`;
          message.links.push({
            title: data.helpInfo.btnTxt || '고객센터',
            url: data.helpInfo.url,
          });
        }

        // 링크 최대 2개 노출
        message.links = message.links.slice(0, 2);

        onSuccess(message);
      } else {
        onError();
      }
    },
    onError,
  });
};
